import $ from 'jquery';

export default () => {
    const slider = $('.js-testimonials-slider');

    if (slider.is('*')) {
        slider.slick({
            fade: true,
            adaptiveHeight: true,
        });
    }
}



// WEBPACK FOOTER //
// ../src/scripts/modules/testimonials.js